import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { OpenGraphTags } from '../../shared/OpenGraphTags';

const isValidUrl = (urlToTest, isImage) => {
  const hasLength = urlToTest && urlToTest.length && typeof(urlToTest) === 'string';

  //Need a try/catch here because atob can error if the string isnt in b64 format
  let decodedUrl = '';
  try {
    decodedUrl = atob(urlToTest);
  }
  catch (e) {

  }

  if(!hasLength) {
    return false;
  }
  else if (isImage && decodedUrl.match(/(\.jpg|\.jpeg|\.png)/gi)) {
    return true;
  }
  else if (!isImage && decodedUrl.match(/athlinks\.com/gi)) {
    return true;
  }

  return false;
};

class ImageShareComponent extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    type: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired
  };

  static defaultProps = {
    type: 'website',
  };

  componentDidMount() {
    window.prerenderReady = true;
  }

  render() {
    const {
      url,
      type,
      title = '',
      description = '',
      image,
      history
    } = this.props;

    const isNotPrerender = window && !!window.isNotPrerender;
    const linkUrlIsValid = isValidUrl(url, false);

    //if not valid url (no length, not athlinks.com) -> 404
    if (!linkUrlIsValid) {
      history.push({pathname: `/error-404`});
    }

    const decodedLinkUrl = atob(url);

    //if valid but not prerender -> redirect to page
    if (isNotPrerender && linkUrlIsValid) {
      const trimmedUrl = decodedLinkUrl.replace(/^.*\/\/[^\/]+/, '');
      history.push({pathname: trimmedUrl});
    }

    const imageUrlIsValid = isValidUrl(image, true);
    //If image url is not valid, OpenGraphTags can use the default
    const decodedImageUrl = imageUrlIsValid
      ? atob(image)
      : '';

    const decodedTitle = decodeURIComponent(title);
    const decodedDescription = decodeURIComponent(description);

    //otherwise render as usual for prerender purposes
    return (
      <div>
        <OpenGraphTags
          ogType={type || 'website'}
          url={decodedLinkUrl}
          title={decodedTitle}
          description={decodedDescription}
          image={decodedImageUrl}
          noImageSize={imageUrlIsValid}
        />
      </div>
    );
  }
}

export const ImageShare = withRouter(ImageShareComponent);



/** WEBPACK FOOTER **
 ** ./views/openGraphShare/ImageShare.js
 **/